import _get from 'lodash.get';

// A list of USER_ACTIONS to help us standardise our event names.
export const SELECTED = 'selected';

export const COMPARE_DEALS_CLICK = 'seeDeals';
export const COMPARE_REVIEWS_CLICK = 'seeDeals';
export const COMPARE_PCP_INFO = 'pcpInfo';
export const COMPARE_TP_INFO = 'tpInfo';
export const COMPARE_NOTIFICATION = 'notification';
export const COMPARE_ADD = 'compareAdd';
export const COMPARE_REMOVE = 'compareRemove';
export const COMPARE_FIND = 'compareFind';
export const COMPARE_OTHER_MANU = 'otherManufacture';
export const COMPARE_DERIVATIVE = 'derivative';

const getFormName = callbackOrMessage =>
  `${callbackOrMessage === 'message' ? 'Email' : 'Callback'}` + ' Enquiry form';

/**
 * Payload for selecting a model.
 * @param {Object} args The arguments sent in.
 * @param {string} args.model The model.
 * @returns {Object} The event's payload.
 */
export const filterForm = ({ itemLabel }) => ({
  action: 'Filter',
  label: itemLabel
});

export const filterFormSearchButtonClick = ({ isPostcodeValid }) => ({
  action: 'Filter',
  label: `Search Results Button Click: Postcode ${
    isPostcodeValid ? 'Valid' : 'Invalid'
  }`
});

export const browseMakes = ({ makePrefix, itemName }) => ({
  action: 'Browse All',
  label: `Used ${makePrefix ? makePrefix + ' ' : ''}${itemName}`
});

export const accordionBrowse = ({ isOpen }) => ({
  action: 'Browse All',
  label: `Accordion: ${isOpen ? 'Open' : 'Close'}`
});

export const accordionDescription = ({ isOpen }) => ({
  action: 'Vehicle Description',
  label: `Accordion: ${isOpen ? 'Open' : 'Close'}`
});

export const accordionSpecification = ({ isOpen }) => ({
  action: 'Specifications',
  label: `Accordion: ${isOpen ? 'Open' : 'Close'}`
});

export const enquiryFormValuesBlur = ({ callbackOrMessage, itemLabel }) => ({
  action: getFormName(callbackOrMessage),
  label: itemLabel
});

export const formSubmission = ({ callbackOrMessage, wasSuccess }) => ({
  action: getFormName(callbackOrMessage),
  label: `Submission Response: ${wasSuccess ? 'Success' : 'Failure'}`
});

export const formSubmitButtonClick = ({ callbackOrMessage, validForm }) => ({
  action: getFormName(callbackOrMessage),
  label: `Submit Button Click: Validation ${validForm ? 'Success' : 'Failure'}`
});

export const backToListings = () => ({
  action: 'Back to listings'
});

export const closeEnquiryModal = () => ({
  action: 'Close enquiry modal'
});

export const moreStockDealer = ({ actionPrefix, dealerId }) => ({
  action: `${actionPrefix}CTA: More Stock From Dealer`,
  label: dealerId
});

export const breadcrumb = ({ displayText }) => ({
  action: 'Breadcrumb',
  label: displayText
});

export const phoneNoClick = ({ actionPrefix, sourceId }) => ({
  action: `${actionPrefix}CTA: Phone Call`,
  label: sourceId
});

export const phoneNoReveal = ({ actionPrefix, sourceId }) => ({
  action: `${actionPrefix}CTA: Phone Number Reveal`,
  label: sourceId
});

export const ctaEmailDealer = ({ actionPrefix, sourceId }) => ({
  action: `${actionPrefix}CTA: Email Dealer Button`,
  label: sourceId
});

export const ctaRequestCallback = ({ actionPrefix, sourceId }) => ({
  action: `${actionPrefix}CTA: Request Callback Button`,
  label: sourceId
});

export const detailsCTA = ({ actionPrefix, sourceId, action }) => ({
  action: `${actionPrefix}${action}`,
  label: sourceId
});

// TODO: shall we make this an object like:

// const card = {
//   click: () => ({
//     label: 'Advert clicked'
//   })
// }

// const carousel = {
//   leftArrow: () => {},
//   rightArrow: () => {},
//   advertClicked: () => {}
// }

export const gallery = ({ itemLabel }) => ({
  action: 'Gallery',
  label: itemLabel
});

export const adListings = ({ itemLabel }) => ({
  action: 'Ad listings',
  label: itemLabel
});

export const alsoConsider = ({ itemLabel }) => ({
  action: 'Also Consider',
  label: itemLabel
});

export const popularCars = ({ itemLabel }) => ({
  action: 'Popular Cars',
  label: itemLabel
});

// If you would prefer to use an object to represent your event namespace and associated
// paylod methods, then add them to the WIDGETS below.
export const WIDGETS = {
  compareCard: {
    deals: {
      [COMPARE_DEALS_CLICK]: ({ make, range }) => ({
        action: 'compare: See deals',
        label: `${make}/${range}`
      })
    },
    reviews: {
      [COMPARE_REVIEWS_CLICK]: ({ make, range }) => ({
        action: 'compare: See reviews',
        label: `${make}/${range}`
      })
    },
    tpinfo: {
      [COMPARE_TP_INFO]: () => ({
        action: 'compare: TP explainer'
      })
    },
    pcpinfo: {
      [COMPARE_PCP_INFO]: () => ({
        action: 'compare: PCP explainer'
      })
    },
    notification: {
      [COMPARE_NOTIFICATION]: () => ({
        action: 'compare: Add compare',
        label: 'notification click through'
      })
    },
    add: {
      [COMPARE_ADD]: ({ make, range }) => ({
        action: 'compare: Add compare',
        label: `${make}/${range}`
      })
    },
    remove: {
      [COMPARE_REMOVE]: ({ make, range }) => ({
        action: 'compare: Remove compare',
        label: `${make}/${range}`
      })
    },
    find: {
      [COMPARE_FIND]: ({ make, range }) => ({
        action: 'compare: Find car',
        label: `${make}/${range}`
      })
    },
    derivative: {
      [COMPARE_DERIVATIVE]: ({ make, range, trim }) => ({
        action: 'compare: Find car',
        label: `${make}/${range}/${trim}`
      })
    }
  },
  dealsManufacturer: {
    other: {
      [COMPARE_OTHER_MANU]: ({ make }) => ({
        action: 'dealsManufacturer: Click manufacturer',
        label: make
      })
    }
  }
};

/**
 * Takes the eventName and calls the appropriate method on the WIDGET object.
 * @param {Object} args The arguments sent in.
 * @param {Object} args.eventName The event name configuration.
 * @param {string[]} args.eventName.namspace The event namespace nesting.
 * @param {Object} args.eventName.action The event action.
 * @returns {Object} The event's payload.
 */
export const callUserActionMethodOnObject = ({
  eventName: { namespace, action },
  ...args
}) => {
  const namespaceArray = [...namespace, action];
  const funcToCall = _get(exports.WIDGETS, namespaceArray);

  if (!funcToCall) {
    throw new Error(`Invalid namespace: ${namespaceArray.join('.')}`);
  }

  return funcToCall(args);
};



// WEBPACK FOOTER //
// ./src/utils/gtm/events/events.dimensions.js